import { Button } from '@progress/kendo-react-buttons'
import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import classnames from 'classnames'
import * as React from 'react'
import { connect } from 'react-redux'
import * as ReactStrap from 'reactstrap'
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import * as Redux from 'redux'
import * as Breadcrumb from '../../components/breadcrumbs'
import { FlashMessage } from '../../components/flash-message';
import * as Help from '../../components/help'
import { Loading } from '../../components/loading'
import * as Menu from '../../components/menu/left-nav'
import * as RasaModal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import * as GridCell from '../grid-cell'
import * as LeadPostActions from '../lead-posts/actions'
import {LeadPostModalConnect} from '../lead-posts/component'
import * as LeadTextActions from '../lead-text/add-edit-modal/actions'
import {AddEditModal} from '../lead-text/add-edit-modal/component'
import { RawAddEditModal } from '../lead-text/add-edit-modal/raw-edit-modal'
import * as LeadTextConstants from '../lead-text/constants'
import * as PromotionActions from '../promotions/actions'
import {PromotionsModalConnect} from '../promotions/component'
import * as Actions from './actions'
import * as Constants from './constants'
import {DateFilter} from './date-filter'
import * as Render from './render'
import * as SendEmailModal from './send-email-modal'
import './styles.css'
import * as Types from './types'

const breadcrumbs: Breadcrumb.Breadcrumbs = Menu.breadcrumbs(Menu.CONTENT_CALENDAR_URL)

interface SendEmailProps {
  onOpen: RasaModal.Toggle,
}

const SendEmail = ({onOpen}: SendEmailProps) => <span>
  <Button
    primary={true}
    onClick={onOpen}
    title="Send a test email.">
    Send Test
  </Button>
  <SendEmailModal.SendEmailModalConnected />
</span>

const SendEmailConnected = connect(
  null,
  {onOpen: SendEmailModal.toggleModal},
)(SendEmail)

interface AppProps {
  contentCalendar: Types.FullComponentState
  app?: Types.State
}

interface SortableLinkProps {
  constant: string
  label: string
  data: Types.CCLeadContent[]
}

interface AllSortableLinkProps extends SortableLinkProps {
  toggleRankModal: Types.ViewAction
  openSortModal: Types.SortAction
}

const SortableLink = ({constant, label, data, openSortModal, toggleRankModal}: AllSortableLinkProps) =>
    <li>
    {data.filter((e: Types.CCLeadContent) => e.type.includes(constant) &&
                                          !e.type.includes(Constants.SPONSORED)).length > 1 ?
      <span onClick={() => {
        openSortModal(constant)
        toggleRankModal()
      }}>
      {label}
      </span> : null}
    </li>

const SortableLinkConnected = connect(
  ({}, ownProps: SortableLinkProps) => ({...ownProps}),
  {
    openSortModal: Actions.openSortModal,
    toggleRankModal: Actions.toggleRankModal,
  },
)(SortableLink)

interface HeaderDispatchProps {
  toggleAddMenu: Types.ViewAction
  toggleSortMenu: Types.ViewAction
  addLeadPost: Types.ViewAction
  addText: Types.EnterEditActionCreator
  addPromo: Types.ViewAction
}

const ContentCalendarHeader = ({toggleAddMenu,
                                toggleSortMenu,
                                addLeadPost,
                                addText,
                                addPromo,
                                contentCalendar}: HeaderDispatchProps & AppProps) => {
  const sortableContent = getSortableContent(contentCalendar.data.items)
  return <div>
  {contentCalendar.modal.isOpen ? null : <FlashMessage />}
  <Breadcrumb.BreadcrumbComponent breadcrumbs={breadcrumbs}/>
  <Row>
    <Col sm="12" md="10" className="page-header--padding">
      <div className="page-header display-flex date-container">
        <SendEmailConnected />
        <DateFilter />
        <Help.Help id="date-filter-help" helpType={'date-filter-help'} />
      </div>
    </Col>
  </Row>
  <Row>
    <span>
      <div className="add-info-menu" onClick={toggleAddMenu}
                                     onMouseLeave={ () => contentCalendar.view.addMenu ? toggleAddMenu() : null}>
        <p className="add-text"> ADD </p>
        <i className="fas fa-caret-down icon"></i>
          <ul className={classnames('add-info-menu-content', {'show-add-menu': contentCalendar.view.addMenu})}>
            <li>
              <span onClick={addLeadPost}>
              Lead Post
              </span>
            </li>
            <li>
              <span  onClick={() => addText(LeadTextConstants.initialLeadText, 'GUI')}>
              Lead Text
              </span>
            </li>
            <li >
              <span onClick={addPromo}>
              Promotion
              </span>
            </li>
          </ul>
     </div>
    </span>
    {sortableContent.length > 0 &&
    <span>
      <div className="add-info-menu" onClick={toggleSortMenu}
                                     onMouseLeave={() => contentCalendar.view.sortMenu ? toggleSortMenu() : null} >
        <p className="add-text">SORT</p>
        <i className="fas fa-caret-down icon"></i>
          <ul className={classnames('add-info-menu-content', {'show-add-menu': contentCalendar.view.sortMenu})}>
            {sortableContent.map((s: any) => {
              return <SortableLinkConnected key={s.type} constant={s.type} label={s.label} data={s.data}/>
            })}
          </ul>
      </div>
    </span>}
 </Row>
</div>
}
const getFilteredContent = (data: Types.CCLeadContent[], categoryType: string ): Types.CCLeadContent[] => {
  return data.filter((e: Types.CCLeadContent) => {
    return e.type.includes(categoryType) && !e.type.includes(Constants.SPONSORED)
  })
}

const getSortableContent = (data: Types.CCLeadContent[]) => {
  return Constants.SORTABLE_CATEGORIES.map((t: string) => ({
    data: getFilteredContent(data, t),
    label: t,
    type: t,
  })).filter((s: any) => s.data.length > 0)
}

export const ContentCalendarHeaderConnected = connect(
  ({contentCalendar}: AppProps & HeaderDispatchProps) => ({contentCalendar}),
{
   addLeadPost: LeadPostActions.onOpen,
   addPromo: PromotionActions.toggleModal,
   addText: LeadTextActions.enterEdit,
   toggleAddMenu: Actions.toggleAddMenu,
   toggleSortMenu: Actions.toggleSortMenu,
  },
)(ContentCalendarHeader)

const isDragging = (data: Types.CCLeadContent[] = []): boolean => {
  return (data.filter((lp: Types.CCLeadContent) => lp.isDragging) || []).length  > 0
}

interface RankModalDispatchProps {
  toggleRankModal: Types.ViewAction
  dispatch: Redux.Dispatch<Redux.Action>,
  saveReorder: Types.SaveReorder
}

export const RankSortModal = ({contentCalendar,
                               toggleRankModal,
                               dispatch,
                               app,
                               saveReorder}: AppProps & RankModalDispatchProps) =>

  <div className={`no-border lead-posts-grid ${isDragging(contentCalendar.data.itemsToSort) && 'dragging'}`}>
    { (contentCalendar.data.itemsToSort || []).length >= 2 ?
      <Modal className="modal-lg" isOpen={contentCalendar.view.rankModal}>
      <ModalHeader toggle={toggleRankModal}>
        Sort order for {contentCalendar.data.itemsToSort[0].type}
      </ModalHeader>
      <ModalBody>
        <Grid data={Request.withDispatch(contentCalendar.data.itemsToSort, dispatch)}
              resizable={true}
              selectedField="isDragging"
              style={{ cursor: 'move' }}
              total={contentCalendar.data.itemsToSort.length}
              >
          <GridColumn cell={Render.DragCell} field="is_active" title=" " width={125}/>
          <GridColumn cell={Render.TypeCell} field="type" title="Type" width={170}/>
          <GridColumn field="content" title="Content" width={300}/>
        </Grid>
      </ModalBody>
      <ModalFooter>
      {contentCalendar.view.isSaving && <Loading size={Loading.Sizes.SMALL} />}
        <Button primary look="outline"
          onClick={() => saveReorder(app.selectedCommunity,
                                contentCalendar.data.itemsToSort,
                                contentCalendar.data.selectedDate, dispatch)}>
          Save
        </Button>
        <Button look="outline" onClick={toggleRankModal}>Cancel</Button>
      </ModalFooter>
      </Modal>
      : null
    }
</div>
export const RankSortModalConnected = connect(({contentCalendar, app}: AppProps & RankModalDispatchProps) =>
({contentCalendar, app}), (dispatch) =>
({
  dispatch,
  saveReorder: Actions.saveReorder,
  toggleRankModal: () => dispatch({type: Constants.TOGGLE_RANK_MODAL}),
}))(RankSortModal)

export const FullCalendarGrid = ({contentCalendar, dispatch}: any) =>
  <div>
    <ReactStrap.Row>
      <ReactStrap.Col>
        <Grid data={Request.withDispatch(contentCalendar.data.items, dispatch)}
              resizable={true}
              sortable={{
                allowUnsort: true,
                mode: 'multiple',
              }}
              sort={contentCalendar.view.sort}
              onSortChange={(e: GridSortChangeEvent) => dispatch({
                                    options: { value: e.sort },
                                    type: Sortable.sortTableConstant(Constants.CALENDAR_SORT),
              })}
              >
          <GridColumn cell={Render.ActiveCell} field="is_active" title="Active" width={125}/>
          <GridColumn cell={Render.TypeCell} field="type" title="Type" width={115}/>
          <GridColumn cell={Render.HtmlCell} field="content" title="Content" width={300}/>
          <GridColumn cell={GridCell.ImageCell} field="preview_image_url" title="Image" sortable={false} width={150}/>
          <GridColumn cell={Render.DateCell} field="start_datetime" title="Start" width={150}/>
          <GridColumn cell={Render.DateCell} field="end_datetime" title="End" width={150}/>
          <GridColumn cell={GridCell.DateTimeCell} field="grid_updated" title="Updated" width={150} />
        </Grid>
      </ReactStrap.Col>
    </ReactStrap.Row>
</div>

export const FullCalendarGridConnected = connect(
  ({contentCalendar}: any) => ({contentCalendar}),
  (dispatch) => ({dispatch}),
)(FullCalendarGrid);

export const FullCalendarView = () => <div>
  <ContentCalendarHeaderConnected />
  <FullCalendarGridConnected />
  <RankSortModalConnected />
  <LeadPostModalConnect />
  <AddEditModal />
  <PromotionsModalConnect />
  <RawAddEditModal />
</div>

export const FullCalendarViewConnected = connect(
  ({contentCalendar, promotions, leadText}: any) => ({contentCalendar, promotions, leadText}),
)(FullCalendarView)



// WEBPACK FOOTER //
// ./src/pages/content-calendar/component.tsx